// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"48bf749f","45":"10f97c8c"}[chunkId] + ".chunk.js";
};